<template>
    <div>
        <h2
            v-t="'Direkte Abteilungszugehörigkeiten'"
            class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
        ></h2>

        <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row">
            <thead>
                <tr class="kgr-table__row">
                    <th
                        v-t="'department'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th
                        v-t="'Start'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th
                        v-t="'Ende'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th class="kgr-table__cell kgr-table__cell--headline"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="departmentRelation in clubEmployeeDepartmentRelations"
                    :key="departmentRelation.id"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        {{ departmentRelation.department.name }}
                        <div
                            v-if="departmentRelation.department.hierarchyPath"
                            class="hierarchyPath"
                        >
                            ({{ departmentRelation.department.hierarchyPath }})
                        </div>
                    </td>
                    <td class="kgr-table__cell">
                        <template v-if="isBeingEdited(departmentRelation)">
                            <div class="form-widget without-label date-picker">
                                <kgr-date-picker
                                    v-model="editRelations[getEditIndex(departmentRelation)].start"
                                    :invalid="getErrorMessageForExistingStartDate(editRelations[getEditIndex(departmentRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(departmentRelation)])"
                                />
                            </div>
                            <div
                                v-if="getErrorMessageForExistingStartDate(editRelations[getEditIndex(departmentRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(departmentRelation)])"
                            >
                                {{ getErrorMessageForExistingStartDate(editRelations[getEditIndex(departmentRelation)]) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ departmentRelation.formattedStart() }}
                        </template>
                    </td>
                    <td class="kgr-table__cell">
                        <template v-if="isBeingEdited(departmentRelation)">
                            <div
                                class="form-widget without-label date-picker"
                                :class="{ }"
                            >
                                <kgr-date-picker
                                    v-model="editRelations[getEditIndex(departmentRelation)].end"
                                    :invalid="getErrorMessageForExistingEndDate(editRelations[getEditIndex(departmentRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(departmentRelation)])"
                                />
                            </div>
                            <div
                                v-if="getErrorMessageForExistingEndDate(editRelations[getEditIndex(departmentRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(departmentRelation)])"
                            >
                                {{ getErrorMessageForExistingEndDate(editRelations[getEditIndex(departmentRelation)]) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ departmentRelation.formattedEnd() }}
                        </template>
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions">
                        <button
                            v-if="departmentRelation.isEditable"
                            type="button"
                            class="kgr-table__action"
                            :disabled="isBeingEdited(departmentRelation)"
                            @click="edit(departmentRelation)"
                        >
                            <kgr-icon-edit
                                :size="15"
                                :disabled="isBeingEdited(departmentRelation)"
                            />
                        </button>
                        <button
                            v-if="departmentRelation.isDeletable"
                            type="button"
                            class="kgr-table__action"
                            @click="remove(departmentRelation)"
                        >
                            <kgr-icon-delete />
                        </button>
                    </td>
                </tr>

                <tr
                    v-if="isCreatable"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        <kgr-department-select
                            v-model="newRelation.department"
                            :club-id="clubId"
                            hide-label
                        />
                    </td>
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label date-picker">
                            <kgr-date-picker
                                v-model="newRelation.start"
                                :invalid="getErrorMessageForNewRelationStartDate(newRelation) !== null || newRelationIsInvalid"
                            />
                        </div>
                        <div v-if="getErrorMessageForNewRelationStartDate(newRelation) !== null || newRelationIsInvalid">
                            {{ getErrorMessageForNewRelationStartDate(newRelation) }}
                        </div>
                    </td>
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label date-picker">
                            <kgr-date-picker
                                v-model="newRelation.end"
                                :invalid="getErrorMessageForNewRelationEndDate(newRelation) !== null || newRelationIsInvalid"
                            />
                        </div>
                        <div v-if="getErrorMessageForNewRelationEndDate(newRelation) !== null || newRelationIsInvalid">
                            {{ getErrorMessageForNewRelationEndDate(newRelation) }}
                        </div>
                    </td>
                    <td class="kgr-table__cell">
&nbsp;
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-button
            v-if="showSaveButton"
            class="button_save"
            :value="$t('saveChanges')"
            :disabled="!isSavable"
            :pending="pendingCreate || pendingUpdate"
            @click="save()"
        />
    </div>
</template>

<script>
import ClubEmployeeDepartmentRelation from '../../js/dto/ClubEmployeeDepartmentRelation.js';
import ClubEmployeeRepository from '../../js/repository/ClubEmployeeRepository.js';
import DatePicker from '../common/form/picker/DatePicker.vue';
import DepartmentSelect from '../common/form/select/DepartmentSelect.vue';
import Error from '../../js/model/Error.js';
import IconDelete from '../common/icon/IconDelete.vue';
import IconEdit from '../common/icon/IconEdit.vue';
import KgrButton from '../common/form/button/KgrButton.vue';
import axios from 'axios';

export default {
    name: 'KgrClubEmployeeDepartmentsRelationsForm',
    components: {
        'kgr-department-select': DepartmentSelect,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-button': KgrButton,
        'kgr-date-picker': DatePicker,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        employeeId: {
            type: Number,
            required: true,
        },
        clubEmployeeDepartmentRelations: {
            type: Array,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            newRelation: new ClubEmployeeDepartmentRelation(),
            editRelations: [],
            pendingCreate: false,
            pendingUpdate: false,
            alertMessages: [],
            newRelationIsInvalid: false,
        };
    },
    computed: {
        showSaveButton() {
            return this.isCreatable
                || this.clubEmployeeDepartmentRelations.filter((r) => r.isEditable).length > 0
                || this.clubEmployeeDepartmentRelations.filter((r) => r.isDeletable).length > 0;
        },
        isSavable() {
            if (this.editRelations.length === 0 && this.newRelation.isEmptyDepartment()) {
                return false;
            }

            const hasInvalidEdits = this.editRelations.filter((editRelation) => !this.isValidDateRange(editRelation)).length > 0;
            if (hasInvalidEdits) {
                return false;
            }

            if (!this.newRelation.isEmptyDepartment() && !this.newRelation.isValidDepartment()) {
                return false;
            }

            return true;
        },
        regexForDate() {
            return new RegExp('^([0-2]\\d|(3)[01])(\\.)(((0)\\d)|((1)[0-2]))(\\.)\\d{4}$');
        },
    },
    methods: {
        isErrorRelation(relation) {
            return relation !== undefined && relation.invalid;
        },
        isBeingEdited(departmentRelation) {
            return this.getEditIndex(departmentRelation) !== -1;
        },
        getEditIndex(departmentRelation) {
            return this.editRelations.map((editRelation) => editRelation.id).indexOf(departmentRelation.id);
        },
        isValidDateRange(departmentRelation) {
            if (!departmentRelation.end) {
                return true;
            }

            if (!departmentRelation.start && departmentRelation.end) {
                return false;
            }

            return this.getDateFromString(departmentRelation.end) >= this.getDateFromString(departmentRelation.start);
        },
        getDateFromString(dateString) {
            const pattern = /(\d{2})\.(\d{2})\.(\d{4})/;

            return new Date(dateString.replace(pattern, '$3-$2-$1'));
        },
        getErrorMessageForExistingStartDate(relation) {
            const editRelation = this.editRelations[this.getEditIndex(relation)];
            if (editRelation.invalid === true) {
                return this.$t('relation.error.overlapping');
            }
            if (!relation.start) {
                return this.$t('Das Startdatum darf nicht leer sein.');
            }
            if (!this.isValidDate(relation.start)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (!this.isValidDateRange(relation)) {
                return this.$t('Das Startdatum darf nicht nach dem Enddatum liegen.');
            }
            return null;
        },
        getErrorMessageForExistingEndDate(relation) {
            if (relation.end && !this.isValidDate(relation.end)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (relation.start && !this.isValidDateRange(relation)) {
                return this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.');
            }
            return null;
        },
        getErrorMessageForNewRelationStartDate(newRelation) {
            if (this.newRelationIsInvalid) {
                return this.$t('department.relation.saveChanges.conflict', { name: this.newRelation.department.name });
            }
            if (!newRelation.isEmptyDepartment() && !newRelation.start) {
                return this.$t('Das Startdatum darf nicht leer sein.');
            }
            if (!newRelation.isEmptyDepartment() && !this.isValidDate(newRelation.start)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (!this.isValidDateRange(newRelation)) {
                return this.$t('Das Startdatum darf nicht nach dem Enddatum liegen.');
            }
            return null;
        },
        getErrorMessageForNewRelationEndDate(newRelation) {
            if (newRelation.end && !this.isValidDate(newRelation.end)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (newRelation.start && !this.isValidDateRange(newRelation)) {
                return this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.');
            }
            return null;
        },
        isValidDate(date) {
            return this.regexForDate.test(date);
        },
        remove(departmentRelation) {
            showConfirm(this.$t('confirm'), this.$t('department.relation.confirm.delete', { name: departmentRelation.department.name }), () => {
                this.editRelations = this.editRelations.filter((r) => r.id !== departmentRelation.id);
                ClubEmployeeRepository
                    .removeDepartment(this.employeeId, departmentRelation.id)
                    .then(() => {
                        this.$notify.success('department.relation.delete.success', { name: departmentRelation.department.name });
                        this.emitUpdated();
                    })
                    .catch(() => {
                        this.$notify.error('saveChanges.error');
                    });
            }, 'Ok');
        },
        edit(departmentRelation) {
            if (this.isBeingEdited(departmentRelation)) {
                return;
            }

            this.editRelations.push(departmentRelation.toData());
        },
        save() {
            this.pendingCreate = true;
            this.pendingUpdate = true;

            const apiCalls = [];
            if (!this.newRelation.isEmptyDepartment()) {
                this.newRelationIsInvalid = false;
                apiCalls.push(this._createRelation());
            }
            if (this.editRelations.length > 0) {
                apiCalls.push(this._updateRelations(this.editRelations));
            }
            if (apiCalls.length === 0) {
                return;
            }

            axios.all(apiCalls)
                .then(() => {
                    if (this.alertMessages.length > 0 || this.newRelationIsInvalid) {
                        this.alertMessages = this.alertMessages.filter((value, index) => this.alertMessages.indexOf(value) === index);
                        this.$notify.error(this.alertMessages);
                    } else {
                        this.$notify.success('saveChanges.success');
                    }
                })
                .finally(() => {
                    this.editRelations = this.editRelations.filter((relation) => relation.invalid === true);
                    this.emitUpdated();
                    this.pendingCreate = false;
                    this.pendingUpdate = false;
                    this.alertMessages = [];
                });
        },
        async _createRelation() {
            this.newRelationIsInvalid = false;
            return ClubEmployeeRepository
                .createDepartmentRelation(this.newRelation.department.id, this.newRelation, this.employeeId)
                .then(() => {
                    this.newRelation = new ClubEmployeeDepartmentRelation();
                    this.newRelationIsInvalid = false;
                })
                .catch((error) => {
                    this.newRelationIsInvalid = true;
                    if (error.status === 409) {
                        this.alertMessages.push(this.$t('{name} ist dieser Abteilung im gewählten Zeitraum bereits zugewiesen.', { name: this.newRelation.employee.fullName }));
                    } else {
                        this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                    }
                });
        },
        _updateRelations(editRelations) {
            return axios.all(editRelations.map(async (departmentRelation) => {
                departmentRelation.invalid = false;
                return ClubEmployeeRepository
                    .updateDepartmentRelation(departmentRelation)
                    .catch(() => {
                        this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                        departmentRelation.invalid = true;
                    });
            }),
            );
        },
        emitUpdated() {
            this.$emit('updated');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.button_save {
    display: block;
    margin-left: auto;
}

div .date-picker {
    border: 1px solid transparent;

    &.invalid {
        border: 1px solid #f44336;
    }
}

.hierarchyPath {
    font-size: 80%;
}
</style>
